import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { HeartHandshake, User, Lock, ArrowRight } from 'lucide-react';
export function Login() {
  const [role, setRole] = useState<'siswa' | 'guru' | 'ortu'>('siswa');
  const navigate = useNavigate();
  const handleLogin = (e: React.FormEvent) => {
    e.preventDefault();
    // Mock login - redirect to home
    navigate('/');
  };
  return <div className="min-h-screen bg-gradient-to-br from-pink-200/50 via-purple-100/30 to-blue-200/50 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8" data-id="element-490">
      <div className="max-w-md w-full bg-white rounded-3xl shadow-xl overflow-hidden" data-id="element-491">
        <div className="bg-gradient-to-r from-pink-400 via-purple-400 to-blue-400 p-8 text-center" data-id="element-492">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-white rounded-2xl mb-4 shadow-sm" data-id="element-493">
            <HeartHandshake className="h-8 w-8 bg-gradient-to-r from-pink-500 to-blue-500 bg-clip-text text-transparent" style={{
            WebkitTextFillColor: 'transparent',
            WebkitBackgroundClip: 'text'
          }} data-id="element-494" />
          </div>
          <h2 className="text-2xl font-bold text-white mb-1" data-id="element-495">
            Selamat Datang di CLBK
          </h2>
          <p className="text-pink-100 text-sm" data-id="element-496">
            Masuk untuk mengakses layanan penuh
          </p>
        </div>

        <div className="p-8" data-id="element-497">
          {/* Role Selection */}
          <div className="flex bg-gray-100 p-1 rounded-xl mb-8" data-id="element-498">
            <button onClick={() => setRole('siswa')} className={`flex-1 py-2 text-sm font-medium rounded-lg transition-all ${role === 'siswa' ? 'bg-white text-primary-dark shadow-sm' : 'text-gray-500 hover:text-gray-700'}`} data-id="element-499">
              Siswa
            </button>
            <button onClick={() => setRole('guru')} className={`flex-1 py-2 text-sm font-medium rounded-lg transition-all ${role === 'guru' ? 'bg-white text-primary-dark shadow-sm' : 'text-gray-500 hover:text-gray-700'}`} data-id="element-500">
              Guru
            </button>
            <button onClick={() => setRole('ortu')} className={`flex-1 py-2 text-sm font-medium rounded-lg transition-all ${role === 'ortu' ? 'bg-white text-primary-dark shadow-sm' : 'text-gray-500 hover:text-gray-700'}`} data-id="element-501">
              Orang Tua
            </button>
          </div>

          <form onSubmit={handleLogin} className="space-y-6" data-id="element-502">
            <div data-id="element-503">
              <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-504">
                {role === 'siswa' ? 'NISN / Username' : role === 'guru' ? 'NIP / Username' : 'Email / Username'}
              </label>
              <div className="relative" data-id="element-505">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-506">
                  <User className="h-5 w-5 text-gray-400" data-id="element-507" />
                </div>
                <input type="text" required className="block w-full pl-10 pr-3 py-3 border border-gray-200 rounded-xl focus:ring-2 focus:ring-primary focus:border-transparent outline-none transition-all bg-gray-50 focus:bg-white" placeholder="Masukkan username" data-id="element-508" />
              </div>
            </div>

            <div data-id="element-509">
              <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-510">
                Password
              </label>
              <div className="relative" data-id="element-511">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-512">
                  <Lock className="h-5 w-5 text-gray-400" data-id="element-513" />
                </div>
                <input type="password" required className="block w-full pl-10 pr-3 py-3 border border-gray-200 rounded-xl focus:ring-2 focus:ring-primary focus:border-transparent outline-none transition-all bg-gray-50 focus:bg-white" placeholder="••••••••" data-id="element-514" />
              </div>
              <div className="flex justify-end mt-2" data-id="element-515">
                <a href="#" className="text-xs text-primary hover:text-primary-dark font-medium" data-id="element-516">
                  Lupa password?
                </a>
              </div>
            </div>

            <button type="submit" className="w-full bg-primary text-white py-3.5 rounded-xl font-bold flex justify-center items-center gap-2 hover:bg-primary-dark transition-all shadow-md hover:shadow-lg" data-id="element-517">
              Masuk <ArrowRight size={18} data-id="element-518" />
            </button>
          </form>

          <div className="mt-8 text-center" data-id="element-519">
            <p className="text-sm text-gray-500" data-id="element-520">
              Belum punya akun?{' '}
              <a href="#" className="text-primary font-bold hover:underline" data-id="element-521">
                Hubungi Admin BK
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>;
}